/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import React from 'react';
import { SerializedEditorState } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { ReadonlyRichTextEditor } from '../../components/rich-text-editor/ReadonlyRichTextEditor';

interface Props {
  className?: string;
  editorState: SerializedEditorState;
}

export const NoteInstructionsEditorViewer = (props: Props) => {

  const { editorState, className = '' } = props;
  const [editor] = useLexicalComposerContext();

  return (
    <div className={`note-instruction-editor-viewer ${className}`} >
      <ReadonlyRichTextEditor
        editorState={editor.parseEditorState(editorState)} />
    </div>
  )
}
